<template>
  <footer
    id="footer"
    class="footer ptb-xlg"
  >
    <div class="main-footer">
      <div class="grid">
        <div class="col-4-12 sm-col-1-1 sm-mb-lg">
          <h5 class="footer-title mb-md">Contact</h5>
          <p class="mb-md">
            Speeldoos Vught
            <br />
            Vliertstraat 6
            <br />
            5261 EL Vught
          </p>
          <p class="mb-md">
            <a href="mailto:info@speeldoosvught.nl">info@speeldoosvught.nl</a>
            <br />
            <a href="mailto:kaartverkoop@speeldoosvught.nl">kaartverkoop@speeldoosvught.nl</a>
            <br />
            <a href="tel:+31737518044">+31 73 75 18 044</a>
          </p>
          <p class="mb-md">
            Openingstijden:
            <br />
            Maandag t/m vrijdag:
            <br />
            10.00 - 22.00 uur
          </p>
          <p>
            De kassa-kaartverkoop is geopend dinsdag van 13.00 - 17.00 uur en één uur voor aanvang film. Telefonisch
            bereikbaar op dinsdagen tussen 13.00 - 16.00 uur. *
          </p>
        </div>

        <div class="col-5-12 push-3-12 sm-col-1-1 sm-push-0">
          <div class="mb-lg">
            <h5 class="footer-title mb-md">Ga snel naar</h5>
            <ul class="no-bullets flex flex-column flex-gap-16">
              <li
                v-for="nav in footerNavItems"
                :key="nav._id"
              >
                <NuxtLink
                  class="no-underline"
                  :to="nav._url"
                >
                  {{ nav.content?.title }}
                </NuxtLink>
              </li>
            </ul>
          </div>

          <div>
            <h5 class="footer-title mb-md">Nieuwsbrief</h5>
            <p class="mb-md">
              Binnenkort beschikbaar zodat je op de hoogte kan blijven van het programma en de laatste actualiteiten.
            </p>
            <!-- <UIHoverAnimationButton
              class="btn btn-primary outline"
              name="Inschrijven"
            /> -->
          </div>
        </div>
      </div>
    </div>

    <div class="sub-footer sm-hide">
      <div class="grid">
        <div class="col-1-1 flex align-center justify-space-between sm-mb-sm">
          <ul class="no-bullets flex align-center sm-justify-center">
            <li>
              <span>&copy; Speeldoos Vught</span>
            </li>
          </ul>
          <ul class="no-bullets flex align-center sm-justify-center">
            <li
              v-for="nav in footerSubNavigation[0]?.children"
              :key="nav.id"
            >
              <NuxtLink
                class="no-underline"
                :to="nav.url"
              >
                {{ nav.name }}
              </NuxtLink>
            </li>
          </ul>
          <span>
            Website by
            <a
              href="https://www.cre8ion.com"
              target="_blank"
            >
              The Cre8ion.Lab
            </a>
          </span>
        </div>
      </div>
    </div>

    <div class="sub-footer-mobile hide sm-show">
      <div class="grid">
        <div class="col-1-1 flex align-center justify-space-between sm-mb-sm">
          <ul class="no-bullets flex flex-gap-24">
            <li>
              <span>&copy; Speeldoos Vught</span>
            </li>
            <li
              v-for="nav in footerSubNavigation[0]?.children"
              :key="nav.id"
            >
              <NuxtLink
                class="no-underline"
                :to="nav.url"
              >
                {{ nav.name }}
              </NuxtLink>
            </li>
            <li>
              <span>
                Website by
                <a
                  href="https://www.cre8ion.com"
                  target="_blank"
                >
                  The Cre8ion.Lab
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import { FOOTER_NAV_ID } from '~/config/elocusConfig'
  const { data: footerNav } = useBaseAsyncData(`/page/${FOOTER_NAV_ID}`)

  // Mapping is required because of API return
  const footerGroups = computed(() => {
    const content = footerNav.value?.content
    if (!content) return []

    return [1, 2, 3, 4, 5]
      .map((i) => ({
        id: i,
        title: content[`section${i}title`],
        pages: content[`section${i}pages`] ?? [],
      }))
      .filter((group) => group.title && group.pages.length > 0)
  })

  const footerNavItems = computed(() => footerGroups.value.flatMap((group) => group.pages))
  const footerSubNavigation = ref(await baseGetNavigationByIds([2119]))
</script>

<style scoped lang="scss">
  .footer {
    background-color: $black;
    color: $white;
    padding: 8rem 0;

    .main-footer {
      margin-bottom: 16.4rem;
      ul {
        margin: 0;
        padding: 0;
      }
    }

    .footer-title {
      font-size: 1.6rem;
      font-weight: 400;
      line-height: 1.4;
      color: $white;
      opacity: 0.6;
    }

    a {
      text-decoration: none;
      transition: all 0.3s var(--ease-fast-in-slow-out);

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .sub-footer {
    font-size: 1.4rem;

    ul {
      gap: 4rem;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        align-items: center;
        display: inline-flex;
        position: relative;
      }
    }
  }

  .sub-footer-mobile {
    font-size: 1.4rem;
  }

  @include media(sm) {
    .footer {
      padding: 5.6rem 0;

      .main-footer {
        margin-bottom: 8rem;
      }
    }
    .sub-footer {
      padding: 0;
    }
  }
</style>
